// Map of reference key → inverse key. When a dictionaryReference displayItem is
// added on a source entry, the inverse is mirrored on the referenced entry.
//
// Populated from the Requirement 11 table plus the German additions from
// Requirement 15.6 (`base verb` → `conjugation`, `formal form is` ↔
// `informal form is`).
//
// Note: `root verb` and `base verb` both map to `conjugation` (many
// conjugations → one root). That's fine — the inverse `conjugation` on the root
// verb points back to each conjugation.
export const INVERSE_KEYS = {
  'verlan form of': 'verlan form',
  'verlan form': 'verlan form of',
  'conjugated form of': 'conjugation',
  'conjugation': 'conjugated form of',
  'root verb': 'conjugation',
  'formal variant is': 'informal variant is',
  'informal variant is': 'formal variant is',
  'synonym is': 'synonym is',
  'antonym is': 'antonym is',
  'slang equivalent is': 'slang equivalent of',
  'slang equivalent of': 'slang equivalent is',
  'short form of': 'short form',
  'short form': 'short form of',
  'negation is': 'negation of',
  'negation of': 'negation is',
  'mild substitute is': 'mild substitute of',
  'mild substitute of': 'mild substitute is',
  'used instead of': 'mild substitute is',
  'related to': 'related to',
  'opposite of': 'opposite of',
  'similar to': 'similar to',
  'feminine form': 'masculine form',
  'masculine form': 'feminine form',
  'base verb': 'conjugation',
  'formal form is': 'informal form is',
  'informal form is': 'formal form is',
};

export function getInverseKey(key) {
  return INVERSE_KEYS[key] || null;
}
